import React from 'react';
import { Navigate } from 'react-router-dom';
import { useWallet } from '../context/WalletContext';
import { useUserData } from '../hooks/useUserData';
import RegisterForm from '../components/register/RegisterForm';
import ConnectButton from '../components/common/ConnectButton';
import Loader from '../components/common/Loader';

const Register = () => {
  const { connected } = useWallet();
  const { isRegistered, initialLoading, refresh } = useUserData();

  if (initialLoading) return <Loader text="Checking Registration" />;

  if (isRegistered) return <Navigate to="/" replace />;

  return (
    <div className="main-content">
      <div className="page-header text-center">
        <h1 className="page-title">Register</h1>
        <p className="page-subtitle">Join Dreamlifeway and start your journey</p>
      </div>

      {!connected ? (
        <div className="connect-prompt">
          <div className="connect-prompt-icon">🔗</div>
          <h2 style={{ marginBottom: 12 }}>Connect Your Wallet</h2>
          <p className="text-muted mb-lg">Connect your wallet to begin registration</p>
          <ConnectButton />
        </div>
      ) : (
        <div style={{ maxWidth: 500, margin: '0 auto' }}>
          <RegisterForm onRegistered={refresh} />
        </div>
      )}
    </div>
  );
};

export default Register;
